import { getRatios } from "./index148.js";
import { RG_TYPE } from "@project-rouge/rg-core";
function getDistribution(sequence, props) {
	const counter = props.targetUnitMix.map((m) => {
		return {
			label: m.label,
			count: 0
		};
	});
	let apartment;
	for (const action of sequence) {
		if (action.unit.type === RG_TYPE.Entrance) apartment = props.dataset.apartments.aboveEntrance[0];
		if (action.unit.type === RG_TYPE.Apartment) apartment = action.unit;
		if (apartment) counter.find((c) => c.label === apartment.data.category).count++;
	}
	return getRatios(counter.map((m) => m.count));
}
export { getDistribution };

//# sourceMappingURL=index149.js.map